import { get, post } from '@/utils/request'
import {
  isValidBlogToken,
  logoutSession,
  markAuthenticated,
  TOKEN_KEY,
  USER_KEY
} from '@/utils/session'

function saveSession(data) {
  const user = {
    id: data.id,
    username: data.username,
    nickname: data.nickname || data.username,
    permissionLevel: data.permissionLevel || 0,
    userTags: data.userTags || '',
    userType: data.userType || 'member',
    expireTime: data.expireTime || null
  }
  localStorage.setItem(TOKEN_KEY, data.token)
  localStorage.setItem(USER_KEY, JSON.stringify(user))
  markAuthenticated()
  return { token: data.token, user }
}

export async function login({ username, password, captchaId, captchaCode }) {
  const res = await post('/blog/auth/login', { username, password, captchaId, captchaCode }, { skipAuthRedirect: true })
  return saveSession(res.data)
}

export async function guestLogin() {
  const res = await post('/blog/auth/guest', undefined, { skipAuthRedirect: true })
  return saveSession(res.data)
}

export async function register({ username, password, nickname }) {
  const res = await post('/blog/auth/register', { username, password, nickname })
  return res
}

export function getCaptcha() {
  return get('/blog/auth/captcha')
}

export function checkUsername(username) {
  return get('/blog/auth/checkUsername', { username })
}

export async function logout() {
  await logoutSession()
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function getUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || 'null')
  } catch (e) {
    return null
  }
}

export function isLoggedIn() {
  return isValidBlogToken(getToken())
}
